import { useCallback } from 'react'
import { useMutation } from '@apollo/client'
import { useWallet } from '@solana/wallet-adapter-react'
import { LOG_OUT } from 'api/auth/logout'
import { clearSolanaWalletSession } from 'features/auth/utils/clear-solana-wallet-session'
import { getPrivySessionBridge } from '../session-bridge'

/**
 * Sign in / sign out (FE-301).
 *
 * Sign out always ends the XYRO cookie session first, then the wallet adapter
 * and the Privy session, and reloads, so the app never keeps a half-closed
 * session.
 */
export const useAuthSession = () => {
  const [commitLogOut, { loading }] = useMutation(LOG_OUT)
  const { disconnect } = useWallet()

  const signIn = useCallback(() => {
    getPrivySessionBridge()?.login()
  }, [])

  const signOut = useCallback(async () => {
    await commitLogOut()
    await disconnect()
    clearSolanaWalletSession()
    await getPrivySessionBridge()?.logout()
    location.reload()
  }, [commitLogOut, disconnect])

  return { signIn, signOut, loading }
}
